import { graphql } from "@/gql";

export const generateCityHeroImageMutation = graphql(`
  mutation GenerateCityHeroImage(
    $id: ID!
    $prompt: String
    $model: ImageGenerationModel
  ) {
    generateCityHeroImage(id: $id, prompt: $prompt, model: $model)
  }
`);
